import Api from '../services/api.js'
import * as types from '../constants'

export function getPlanPermissionsRequest(){
  return {
    type: types.GET_PLAN_PERMISSIONS_REQUEST
  }
}

export function getPlanPermissionsSuccess(body){
  return {
    type: types.GET_PLAN_PERMISSIONS_SUCCESS,
    body: body
  }
}

export function getPlanPermissionsFailure(exception){
  return {
    type: types.GET_PLAN_PERMISSIONS_FAILURE,
    exception: exception
  }
}

export function updatePlanPermissionsRequest(){
  return {
    type: types.UPDATE_PLAN_PERMISSIONS_REQUEST
  }
}

export function updatePlanPermissionsSuccess(body){
  return {
    type: types.UPDATE_PLAN_PERMISSIONS_SUCCESS,
    body: body
  }
}

export function updatePlanPermissionsFailure(exception){
  return {
    type: types.UPDATE_PLAN_PERMISSIONS_FAILURE,
    exception: exception
  }
}

export function getUserPlanPermissionMatrixValuesRequest(){
  return {
    type: types.GET_USER_PLAN_PERMISSION_MATRIX_VALUES_REQUEST
  }
}

export function getUserPlanPermissionMatrixValuesSuccess(body){
  return {
    type: types.GET_USER_PLAN_PERMISSION_MATRIX_VALUES_SUCCESS,
    body: body
  }
}

export function getUserPlanPermissionMatrixValuesFailure(exception){
  return {
    type: types.GET_USER_PLAN_PERMISSION_MATRIX_VALUES_FAILURE,
    exception: exception
  }
}

export function getPlanPermissions(options) {
  const params = { params: options }
  return dispatch => {
    dispatch(getPlanPermissionsRequest());
    const api = new Api();
    return api.get("/__api/v1/plan_permissions", params)
    .then(response => {
      dispatch(getPlanPermissionsSuccess(response.data))
    })
    .catch(err => dispatch(getPlanPermissionsFailure(err)));
  }
}

export function updatePlanPermission(planPermission) {
  const params = {
    plan_id: planPermission.plan_id,
    user_id: planPermission.user_id,
    can_read: planPermission.can_read,
    can_update: planPermission.can_update,
  }

  return dispatch => {
    dispatch(updatePlanPermissionsRequest());
    const api = new Api();
    return api.put(`/__api/v1/plan_permission/${planPermission.id}`, params)
    .then(response => {
      dispatch(updatePlanPermissionsSuccess(response.data))
    })
    .catch(err => dispatch(updatePlanPermissionsFailure(err)));
  }
}

export function getUserPlanPermissionMatrixValues(options){
  const params = { params: options }
  return dispatch => {
    dispatch(getUserPlanPermissionMatrixValuesRequest());
    const api = new Api();
    return api.get("/__api/v1/user_plan_permission_matrix_values", params)
    .then(response => {
      dispatch(getUserPlanPermissionMatrixValuesSuccess(response.data))
    })
    .catch(err => dispatch(getUserPlanPermissionMatrixValuesFailure(err)));
  }
}



// WEBPACK FOOTER //
// ./src/actions/plan_permission.js